import TextField from "@mui/material/TextField";
import AuraControlledAutocomplete from "app/main/apps/common/AuraControlledAutocomplete";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getContainerNumber, getOrderStatuses } from "../../e-commerce/store/ordersSlice";
import { getOrderTypeLocations } from "../store/shipmentOrderSlice";

function CreateContainerForm() {
  const dispatch = useDispatch();
  const methods = useFormContext();
  const { control, formState, setValue, reset, watch } = methods;
  const { errors } = formState;
  const [shippingCompany, setShippingCompany] = useState([]);
  const [orderType, setOrderType] = useState([]);
  const [orderTypeLocation, setOrderTypeLocation] = useState([]);

  const selectedOrderType = watch("order_type");

  useEffect(() => {
    reset();
  }, []);

  // calls the category value for shipping_company and order_type
  useEffect(() => {
    dispatch(getOrderStatuses({ params: { c: "shipping_company" } })).then(
      (response) => {
        const shippingCompanyRes = response?.payload?.data || [];
        setShippingCompany(shippingCompanyRes);
      }
    );
    dispatch(getOrderStatuses({ params: { c: "order_type" } })).then(
      (response) => {
        const orderTypes = response?.payload?.data || [];
        setOrderType(orderTypes);
      }
    );
  }, []);

  // calls the location api when order type is selected
  useEffect(() => {
    if (selectedOrderType) {
      setOrderTypeLocation([]);
      setValue("location", null); 
      setValue("container_number", null); 

      const orderTypeName =
        selectedOrderType.name || selectedOrderType.value || selectedOrderType;
      dispatch(getOrderTypeLocations({ order_type: orderTypeName })).then(
        (response) => {
          const orderTypeLocations = response?.payload || [];
          setOrderTypeLocation(orderTypeLocations);
        }
      );
      dispatch(getContainerNumber({ filter: orderTypeName })).then(
        (response) =>{
          const containerNo = response?.payload?.container_number || '';
          setValue("container_number", containerNo, {shouldValidate: true});
        }
      );
    } else {
      setOrderTypeLocation([]);
      setValue("location", null);
      setValue("container_number", null); 
    }
  }, [selectedOrderType, dispatch, setValue]);

  return (
    <>
      <div className="flex flex-col gap-4 w-full">
        <div className="grid grid-cols-4 gap-10 w-full items-start">
          {/* Order Type */}
          <div className="col-span-1">
            <AuraControlledAutocomplete
              className="m-0"
              labelName="Order Type"
              control={control}
              controlName="order_type"
              inputValues={orderType || []}
              required
              error={!!errors?.order_type?.message}
              helperText={errors?.order_type?.message}
            />
          </div>

          {/* Location */}
          <div className="col-span-1">
            <AuraControlledAutocomplete
              className="m-0"
              labelName="Location"
              control={control}
              controlName="location"
              inputValues={orderTypeLocation || []}
              required
              error={!!errors?.location?.message}
              helperText={errors?.location?.message}
            />
          </div>

          {/* ETA Date */}
          <div className="col-span-1">
            <Controller
              control={control}
              name="eta_date"
              render={({ field }) => (
                <TextField
                  {...field}
                  id="eta_date"
                  label="Est. Delivery"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </div>

          {/* Container Number */}
          <div className="col-span-1">
            <Controller
              control={control}
              name="container_number"
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Container Number"
                  id="container_number"
                  value={field.value ?? ''} 
                  onChange={(e) => field.onChange(e.target.value)}  
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                  error={!!errors.container_number}
                  helperText={errors?.container_number?.message}
                />
              )}
            />
          </div>

        </div>
      </div>
    </>
  );
}

export default CreateContainerForm;
